import api from '@/http/api';
import { Activite } from '@/models/Activite';
import { ElementFriseActiviteDocument } from '@/models/ElementFriseActiviteDocument';
import { Etablissement } from '@/models/Etablissement';
import { Individu } from '@/models/Individu';
import { PaletteDocument } from '@/models/PaletteDocument';
import { Pointage } from '@/models/Pointage';
import { Supplement } from '@/models/Supplement';
import { TarifActiviteDocument } from '@/models/TarifActiviteDocument';
import { TarifEventSchedulerActiviteDocument } from '@/models/TarifEventSchedulerActiviteDocument';
import router from '@/router';
import { RootState } from '@/store/types';
import { utils } from '@/util';
import { Action, ActionTree } from 'vuex';
import { PointageState, POINTAGES_STORE as s } from './type';


import db from "@/db";
import { GroupeIndividu } from '@/models/GroupeIndividu';

/**
 * Récuperer la liste des pointages
 */
export const fetchListPointages: Action<PointageState, RootState> = ({ commit, rootGetters, dispatch }) => {
    const start = Date.now();
    return new Promise((resolve, reject) => {
        let currentActivite = rootGetters.getCurrentActivite as Activite;
        console.log("fetchListPointages")
        
        //Selon type d'activité choisi la date d'aujourd'hui ou la date de la frise
        let now = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        api.pointagesController.listPointages(now, currentActivite.getId()).then((rep: Array<Pointage>) => {
            console.log(`fetchListPointages loading : ${Date.now() - start} ms`);
            commit(s.SET_POINTAGE_ENCOURS, rep)
            resolve("done")
            dispatch('fetchIndividusPresents')
            if (rootGetters.getListIndividus.length !== rootGetters.getFiltredListIndividus)
                dispatch('fetchIndividusFiltreesPresents');
        }).catch((e: any) => {
            console.error(e)
            router.push("/erreurs/" + e);
        }).finally(()=>{            
            console.log(`fetchListPointages Execution time: ${Date.now() - start} ms`);
        })
    })
};

export const removeDeletedPointages: Action<PointageState, RootState> = ({ state, commit }) => {
    return new Promise((resolve, reject) => {
        let listProm: Array<Promise<any>> = [];
        let newList = state.pointageEnCours.filter((pointage: Pointage) => {
            if (pointage.isIsInoe() && pointage.getPdetail_id() !== -1 && pointage.getUsername() === "Inoe") {
                let pdetail: any = db.getPointageDetailInoe(pointage.getPdetail_id());
                if (typeof pdetail === 'undefined' || pdetail.length === 0) {
                    console.warn(`Le pointage ${pointage.getPdetail_id()} à été supprimé de Inoe`)
                    listProm.push(api.pointagesController.supprimerPointage(pointage.get_id()));
                    return false;
                } else
                    return true;

            } else
                return true;
        });
        Promise.all(listProm).then(() => {
            commit(s.SET_POINTAGE_ENCOURS, newList);
            resolve("done")
        })
    })
};
export const removeDeletedSupplements: Action<PointageState, RootState> = ({ state, commit }) => {
    return new Promise((resolve, reject) => {
        let listProm: Array<Promise<any>> = [];
        let newList = state.listSupplementsActifs.filter((supp: Supplement) => {
            if (supp.isIsInoe() && supp.getPdetail_id() !== -1 && supp.getUsername() === "Inoe") {
                let pdetail: any = db.getSupplementPointageInoe(supp.getPdetail_id());
                if (typeof pdetail === 'undefined' || pdetail.length === 0) {
                    console.warn(`Le supplement ${supp.getPdetail_id()} à été supprimé de Inoe`)
                    listProm.push(api.pointagesController.supprimerPointage(supp.get_id()));
                    return false;
                } else
                    return true;
            } else
                return true;
        });
        Promise.all(listProm).then(() => {
            commit(s.SET_SUPPLEMENTS_ACTIFS, newList)
            resolve("supplementactif done")
        })
    })
}
/**
 * Récuperer la liste des temps d'accueil TEMPS ET HEURES
 */
export const fetchListTempsAccueil: Action<PointageState, RootState> = ({ state, commit, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let currentActivite = rootGetters.getCurrentActivite as Activite;
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");

        let listSeances = currentActivite.getSeances(currentDate.format('YYYY-MM-DD'));
        if (listSeances.length !== 0) {
            //Retirer les doublons
            listSeances = listSeances.filter((thing, index, self) =>
                index === self.findIndex((t) => (
                    (t.getStart_date() === thing.getStart_date() &&
                        t.getEnd_date() === thing.getEnd_date())
                    &&

                    (typeof t.getPlageFonctionnement_id() !== 'undefined' &&
                        typeof thing.getPlageFonctionnement_id() !== 'undefined' &&
                        t.getResource_id() === "AC" &&
                        thing.getResource_id() === "AC" &&
                        t.getPlageFonctionnement_id() === thing.getPlageFonctionnement_id())

                    ||

                    ((typeof t.getService_id() !== 'undefined' &&
                        typeof thing.getService_id() !== 'undefined' &&
                        t.getResource_id() === "AC" &&
                        thing.getResource_id() === "AC" &&
                        t.getService_id() === thing.getService_id()))

                    ||

                    (t.getPlageIntitule() === thing.getPlageIntitule())

                ))
            )

            if (currentActivite.isHoraires_fixes()) {
                let elementsFrisesActivite: Array<ElementFriseActiviteDocument> = currentActivite.getElementFriseActivite();
                listSeances.forEach((tempsAccueil: TarifEventSchedulerActiviteDocument) => {
                    elementsFrisesActivite.forEach((elementFriseActivite: any) => {
                        if (tempsAccueil.getFriseElement_id() === elementFriseActivite.id) {
                            if (elementFriseActivite.heure_debut_fixe)
                                tempsAccueil.setHeure_debut_fixe(utils.getDateFromString(elementFriseActivite.heure_debut_fixe, "HH:mm:ss").format("HH:mm"))
                            if (elementFriseActivite.heure_fin_fixe)
                                tempsAccueil.setHeure_fin_fixe(utils.getDateFromString(elementFriseActivite.heure_fin_fixe, "HH:mm:ss").format("HH:mm"))
                        }
                    });
                });
            }
            commit(s.SET_LIST_TEMPS_ACCUEIL, listSeances);
            commit(s.SET_LIST_TEMPS_ACCUEIL_FILTRED, listSeances);
            resolve('listtempsaccueil done')
        } else {
            reject("no-seances-found")
        }
    })
};

/**
 * Créer un nouveau pointage arrivée
 * @param params [ TarifEventSchedulerActiviteDocument, Individu ]
 */
export const addPointageArrivee: Action<PointageState, RootState> = ({ state, dispatch, rootGetters, getters }, params) => {
    return new Promise((resolve, reject) => {
        let seance: TarifEventSchedulerActiviteDocument = params[0];
        let ind: Individu = params[1];
        let pointage = new Pointage({});
        let splitedDate = (rootGetters.getDate as string).split('-');
        let now = utils.getCurrentTimeNow(splitedDate[0], splitedDate[1], splitedDate[2]);
        let palette: PaletteDocument = state.paletteEncours;
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        let currentUser = rootGetters.getCurrentUser;
        let listPrevi = state.listPointagesPrevi;
        let previ: any;
        let pointages: Array<Pointage> = []

        let inscription = ind.getInscriptionActivite(currentActiviteId);
        if (typeof inscription !== 'undefined' && inscription) {
            pointage.setIdInscription(inscription.getId());
            if (rootGetters.getCurrentActivite.isGroupes()) {
                pointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
            } else {
                pointage.setGroupeId(-1)
            }

        } else {
            reject("InscriptionNotFound")
        }
        if (seance.getHeure_debut_fixe())
            pointage.setTempsDebut(now.format('YYYY-MM-DD') + " " + seance.getHeure_debut_fixe() + ":00");
        else if (
            now.isBetween(
                utils.getDateFromString(seance.getStart_date(), "YYYY-MM-DD HH:mm:ss"),
                utils.getDateFromString(seance.getEnd_date(), "YYYY-MM-DD HH:mm:ss")
            ))
            pointage.setTempsDebut(now.format('YYYY-MM-DD HH:mm:ss'));
        else
            pointage.setTempsDebut(seance.getStart_date());

        if (seance.getHeure_fin_fixe()) {
            let tempsFixe = utils.getDateFromString(now.format('YYYY-MM-DD') + " " + seance.getHeure_fin_fixe() + ":00", "YYYY-MM-DD HH:mm:ss");
            let timeFin = utils.getDateFromString(seance.getEnd_date(), "YYYY-MM-DD HH:mm:ss");

            if (tempsFixe > timeFin) {
                //Heure fixe est supérieur à l'heure de fin
                pointage.setTempsFin(seance.getEnd_date());

                let seances = getters.getListTempsAccueil.filter((temps: TarifEventSchedulerActiviteDocument) => {
                    return temps.getResource_id() === "AC" &&
                        temps.getId() !== seance.getId() &&
                        utils.getDateFromString(temps.getEnd_date(), "YYYY-MM-DD HH:mm:ss") <= tempsFixe &&
                        utils.getDateFromString(temps.getStart_date(), "YYYY-MM-DD HH:mm:ss") >= utils.getDateFromString(seance.getStart_date(), "YYYY-MM-DD HH:mm:ss")
                })
                seances.forEach((temps: TarifEventSchedulerActiviteDocument) => {
                    let pointageExistant = getters.getPointageEnCours.find((pointageEnCours: Pointage) => pointageEnCours.getElementFriseId() === temps.getFriseElement_id() &&
                        pointageEnCours.getIdIndividu() === ind.getId());
                    if (typeof pointageExistant === 'undefined') {
                        let newPointage = new Pointage({})
                        let inscription = ind.getInscriptionActivite(currentActiviteId);
                        if (typeof inscription !== 'undefined' && inscription) {
                            newPointage.setIdInscription(inscription.getId());
                            if (rootGetters.getCurrentActivite.isGroupes()) {
                                newPointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                            } else {
                                newPointage.setGroupeId(-1)
                            }

                        } else {
                            reject("InscriptionNotFound")
                        }

                        newPointage.setTempsDebut(temps.getStart_date());
                        newPointage.setTempsFin(temps.getEnd_date());
                        newPointage.setDatePointage(now.format('YYYYMMDD'));
                        newPointage.setTypePointage("REEL");
                        newPointage.setIdIndividu(ind.getId());
                        newPointage.setElementFriseId(temps.getFriseElement_id());
                        newPointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + temps.getFriseElement_id() + ind.getId());
                        newPointage.setIsInoe(false);
                        newPointage.setUsername(currentUser.login);
                        previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && item.individu_id === ind.getId());
                        if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
                            newPointage.setPaletteId(previ.palette_id);
                        } else {
                            newPointage.setPaletteId(palette.getId());
                        }

                        pointages.push(newPointage)
                    }

                });
            } else
                pointage.setTempsFin(now.format('YYYY-MM-DD') + " " + seance.getHeure_fin_fixe() + ":00");
        } else
            pointage.setTempsFin("");
        pointage.setDatePointage(now.format('YYYYMMDD'));
        pointage.setTypePointage("REEL");
        pointage.setIdIndividu(ind.getId());
        pointage.setIsInoe(false);
        pointage.setUsername(currentUser.login);
        if (seance.getResource_id() === 'AC' || seance.getResource_id() === 'JO') {
            previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && item.individu_id === ind.getId());
            pointage.setElementFriseId(seance.getFriseElement_id());
            pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + seance.getFriseElement_id() + ind.getId());
        } else {
            if (seance.getResource_id() === 'TS') {
                previ = listPrevi.find((item: any) => item.tariftempssupplactivite_id === seance.getTempsTarif_id() && item.individu_id === ind.getId());
                pointage.setTempsSupplementaireId(seance.getTempsTarif_id());
                pointage.setTempsSupplementaireIntitule(seance.getPlageIntitule());
                pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + seance.getTempsTarif_id() + ind.getId());
            }
        }
        if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
            pointage.setPaletteId(previ.palette_id);
        } else {
            pointage.setPaletteId(palette.getId());
        }

        pointages.push(pointage);
        if (pointages.length === 1)
            api.pointagesController.pointer(pointages[0]).then((rep: any) => {
                rep.ok ? resolve("Success") : reject("")
                dispatch("fetchListPointages")
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })
        else
            api.pointagesController.pointageMasse(pointages).then((rep: any) => {
                console.log("BULKADD", rep)
                rep.length === 0 ? resolve("Success") : reject("")
                dispatch("fetchListPointages")
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })

    })
};

/**
 * Créer un pointage arrivée global
 * @param params [ "arrivée"|"départ", TarifEventSchedulerActiviteDocument, "DateTime" ]
 */
export const addPointageArriveeGlobal: Action<PointageState, RootState> = ({ commit, getters, dispatch, state, rootGetters }, params) => {
    return new Promise((resolve, reject) => {
        let seance: TarifEventSchedulerActiviteDocument = params[1];
        let listind: Array<Individu> = Array.from(rootGetters.getFiltredListIndividus);
        let splitedDate = (rootGetters.getDate as string).split('-');
        let now = utils.getCurrentTimeNow(splitedDate[0], splitedDate[1], splitedDate[2]);
        let listpointage: Array<Pointage> = [];
        let palette: PaletteDocument = state.paletteEncours;
        let currentActiviteId = rootGetters.getCurrentActivite.getId() as number;
        let currentUser = rootGetters.getCurrentUser;
        let listPrevi = state.listPointagesPrevi;
        let previ: any;

        //Recup pointage actif
        let pointageactif = getters.getPointageEnCours as Array<Pointage>;
        //Filtrer selon la séance
        let pointageActifTemps: Array<Pointage> = pointageactif.filter(
            (item: any) => {
                if (
                    item.getElementFriseId() === seance.getFriseElement_id()
                ) {
                    return item;
                }
            }
        ) as Array<Pointage>;
        //Retirer les enfants déja pointer
        pointageActifTemps.forEach((pointage: Pointage) => {
            /*let i: any = listind.findIndex(
                enfant => enfant.getId() === pointage.getIdIndividu()
            );
            listind.splice(i, 1);*/
            listind = listind.filter((e : Individu)=>{
                return e.getId() !== pointage.getIdIndividu()
            })

        });
        if (listind.length === 0) {
            pointageActifTemps.forEach((pointage: Pointage) => {
                if (!pointage.isIsInoe())
                    pointage.setTempsDebut(params[2])
            });
            api.pointagesController.pointageMasse(pointageActifTemps).then((rep: any) => {
                rep.length === 0 ? resolve("Success") : reject("")
            }).finally(() => {
                dispatch("fetchListPointages")
            })
        } else {
            let allowPointage: boolean
            listind.forEach((ind: Individu) => {
                //  
                allowPointage = true;
                pointageactif.forEach((pointage: any) => {
                    if (
                        pointage.idIndividu === ind.getId() &&
                        utils
                            .getDateFromString(pointage.tempsDebut, "YYYY-MM-DD HH:mm:ss")
                            .format("YYYY-MM-DD HH:mm:ss") <
                        utils
                            .getDateFromString(seance.getStart_date(), "YYYY-MM-DD HH:mm:ss")
                            .format("YYYY-MM-DD HH:mm:ss") &&
                        pointage.tempsFin === ""
                    )
                        allowPointage = false;
                    else if (
                        pointage.idIndividu === ind.getId() &&
                        pointage.tempsFin !== "" &&
                        pointage.tempsDebut === "" &&
                        utils
                            .getDateFromString(pointage.tempsFin, "YYYY-MM-DD HH:mm:ss")
                            .format("YYYY-MM-DD HH:mm:ss") <=
                        utils
                            .getDateFromString(seance.getStart_date(), "YYYY-MM-DD HH:mm:ss")
                            .format("YYYY-MM-DD HH:mm:ss")
                    )
                        allowPointage = true;
                });

                //
                if (allowPointage) {
                    let pointage = new Pointage({});
                    let inscription = ind.getInscriptionActivite(currentActiviteId);
                    if (typeof inscription !== 'undefined' && inscription) {
                        pointage.setIdInscription(inscription.getId());
                        if (rootGetters.getCurrentActivite.isGroupes()) {
                            pointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                        } else {
                            pointage.setGroupeId(-1)
                        }

                    } else {
                        reject("InscriptionNotFound")
                    }
                    pointage.setTempsDebut(params[2]);
                    if (seance.getHeure_fin_fixe()) {
                        let tempsFixe = utils.getDateFromString(now.format('YYYY-MM-DD') + " " + seance.getHeure_fin_fixe() + ":00", "YYYY-MM-DD HH:mm:ss");
                        let timeFin = utils.getDateFromString(seance.getEnd_date(), "YYYY-MM-DD HH:mm:ss");

                        if (tempsFixe > timeFin) {
                            pointage.setTempsFin(seance.getEnd_date());

                            let seances = getters.getListTempsAccueil.filter((temps: TarifEventSchedulerActiviteDocument) => {
                                return temps.getResource_id() === "AC" &&
                                    temps.getId() !== seance.getId() &&
                                    utils.getDateFromString(temps.getEnd_date(), "YYYY-MM-DD HH:mm:ss") <= tempsFixe &&
                                    utils.getDateFromString(temps.getStart_date(), "YYYY-MM-DD HH:mm:ss") >= utils.getDateFromString(seance.getStart_date(), "YYYY-MM-DD HH:mm:ss")
                            });
                            seances.forEach((temps: TarifEventSchedulerActiviteDocument) => {
                                let pointageExistant = getters.getPointageEnCours.find((pointageEnCours: Pointage) => pointageEnCours.getElementFriseId() === temps.getFriseElement_id() &&
                                    pointageEnCours.getIdIndividu() === ind.getId());
                                if (typeof pointageExistant === 'undefined') {
                                    let newPointage = new Pointage({})
                                    let inscription = ind.getInscriptionActivite(currentActiviteId);
                                    if (typeof inscription !== 'undefined' && inscription) {
                                        newPointage.setIdInscription(inscription.getId());
                                        if (rootGetters.getCurrentActivite.isGroupes()) {
                                            newPointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                                        } else {
                                            newPointage.setGroupeId(-1)
                                        }

                                    } else {
                                        reject("InscriptionNotFound")
                                    }

                                    newPointage.setTempsDebut(temps.getStart_date());
                                    newPointage.setTempsFin(temps.getEnd_date());
                                    newPointage.setDatePointage(now.format('YYYYMMDD'));
                                    newPointage.setTypePointage("REEL");
                                    newPointage.setIdIndividu(ind.getId());
                                    newPointage.setElementFriseId(temps.getFriseElement_id());
                                    newPointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + temps.getFriseElement_id() + ind.getId());
                                    newPointage.setIsInoe(false);
                                    newPointage.setUsername(currentUser.login);
                                    previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && item.individu_id === ind.getId());
                                    if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
                                        newPointage.setPaletteId(previ.palette_id);
                                    } else {
                                        newPointage.setPaletteId(palette.getId());
                                    }

                                    listpointage.push(newPointage)
                                }

                            });
                        } else
                            pointage.setTempsFin(now.format('YYYY-MM-DD') + " " + seance.getHeure_fin_fixe() + ":00");
                    }
                    else
                        pointage.setTempsFin("");
                    pointage.setDatePointage(now.format('YYYYMMDD'));
                    pointage.setTypePointage("REEL");
                    pointage.setIdIndividu(ind.getId());
                    pointage.setIsInoe(false);
                    pointage.setUsername(currentUser.login);
                    if (seance.getResource_id() === 'AC' || seance.getResource_id() === 'JO') {
                        previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && item.individu_id === ind.getId());
                        pointage.setElementFriseId(seance.getFriseElement_id());
                        pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + seance.getFriseElement_id() + ind.getId());

                    } else {
                        if (seance.getResource_id() === 'TS') {
                            previ = listPrevi.find((item: any) => item.tariftempssupplactivite_id === seance.getTempsTarif_id() && item.individu_id === ind.getId());
                            pointage.setTempsSupplementaireId(seance.getTempsTarif_id());
                            pointage.setTempsSupplementaireIntitule(seance.getPlageIntitule());
                            pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + seance.getTempsTarif_id() + ind.getId());
                        }
                    }
                    if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
                        pointage.setPaletteId(previ.palette_id);
                    } else {
                        pointage.setPaletteId(palette.getId());
                    }
                    listpointage.push(pointage);
                }
            });
            let lastaction = {
                name: "PointageGlobalArrive",
                value: listpointage
            }
            commit(s.SET_LAST_ACTION, lastaction);
            api.pointagesController.pointageMasse(listpointage).then((rep: any) => {
                rep.length === 0 ? resolve("Success") : reject("")
                dispatch("fetchListPointages")
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })
        }
    })
};

/**
 * Créer un pointage départ
 * @param params [ TarifEventSchedulerActiviteDocument, Individu ]
 */
export const addPointageDepart: Action<PointageState, RootState> = ({ getters, dispatch, state, rootGetters }, params) => {
    return new Promise((resolve, reject) => {
        let seance: TarifEventSchedulerActiviteDocument = params[0];
        let splitedDate = (rootGetters.getDate as string).split('-');
        let now = utils.getCurrentTimeNow(splitedDate[0], splitedDate[1], splitedDate[2]);
        let ind: Individu = params[1];
        let pointage = new Pointage({});
        let pointages: Array<Pointage> = []
        let palette: PaletteDocument = state.paletteEncours;
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        let pointageDepart: Pointage | undefined = state.pointageEnCours.find((item: any) =>
            item.elementFriseId === seance.getFriseElement_id()
            && item.idIndividu === params[1].id)
        let currentUser = rootGetters.getCurrentUser;
        let listPrevi = state.listPointagesPrevi;
        let previ: any;

        //Pointage départ simple
        if (pointageDepart !== undefined) {
            // Verifier si on est sur la bonne plage horaire
            // && Vérifier si le temps T n'est pas supérieur à l'arrivé
            if (seance.getHeure_fin_fixe()) {
                let tempsFixe = utils.getDateFromString(now.format('YYYY-MM-DD') + " " + seance.getHeure_fin_fixe() + ":00", "YYYY-MM-DD HH:mm:ss");
                let timeFin = utils.getDateFromString(seance.getEnd_date(), "YYYY-MM-DD HH:mm:ss");


                if (tempsFixe > timeFin) {
                    //Heure fixe est supérieur à l'heure de fin
                    pointageDepart.setTempsFin(seance.getEnd_date());
                    let seances = getters.getListTempsAccueil.filter((temps: TarifEventSchedulerActiviteDocument) => {
                        return temps.getId() !== seance.getId() &&
                            utils.getDateFromString(temps.getEnd_date(), "YYYY-MM-DD HH:mm:ss") <= tempsFixe &&
                            utils.getDateFromString(temps.getStart_date(), "YYYY-MM-DD HH:mm:ss") >= utils.getDateFromString(seance.getStart_date(), "YYYY-MM-DD HH:mm:ss")
                    })
                    seances.forEach((temps: TarifEventSchedulerActiviteDocument) => {
                        let pointageExistant = getters.getPointageEnCours.find((pointageEnCours: Pointage) => pointageEnCours.getElementFriseId() === temps.getFriseElement_id() &&
                            pointageEnCours.getIdIndividu() === ind.getId());
                        if (typeof pointageExistant === 'undefined') {
                            let newPointage = new Pointage({})
                            let inscription = ind.getInscriptionActivite(currentActiviteId);
                            if (typeof inscription !== 'undefined' && inscription) {
                                newPointage.setIdInscription(inscription.getId());
                                if (rootGetters.getCurrentActivite.isGroupes()) {
                                    newPointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                                } else {
                                    newPointage.setGroupeId(-1)
                                }

                            } else {
                                reject("InscriptionNotFound")
                            }

                            newPointage.setTempsDebut(temps.getStart_date());
                            newPointage.setTempsFin(temps.getEnd_date());
                            newPointage.setDatePointage(now.format('YYYYMMDD'));
                            newPointage.setTypePointage("REEL");
                            newPointage.setIdIndividu(ind.getId());
                            newPointage.setElementFriseId(temps.getFriseElement_id());
                            newPointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + temps.getFriseElement_id() + ind.getId());
                            newPointage.setIsInoe(false);
                            newPointage.setUsername(currentUser.login);
                            previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && item.individu_id === ind.getId());
                            if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
                                newPointage.setPaletteId(previ.palette_id);
                            } else {
                                newPointage.setPaletteId(palette.getId());
                            }

                            pointages.push(newPointage)
                        }

                    });
                } else
                    pointageDepart.setTempsFin(now.format('YYYY-MM-DD') + " " + seance.getHeure_fin_fixe() + ":00");
            }
            else if (
                now.isBetween(
                    utils.getDateFromString(seance.getStart_date(), "YYYY-MM-DD HH:mm:ss"),
                    utils.getDateFromString(seance.getEnd_date(), "YYYY-MM-DD HH:mm:ss")
                )
                && now.format("HH:mm") > utils.getDateFromString(pointageDepart.getTempsDebut(), "YYYY-MM-DD HH:mm:ss").format("HH:mm")
            ) {
                pointageDepart.setTempsFin(now.format('YYYY-MM-DD HH:mm:ss'));
            }
            //Sinon mettre l'heure par défault (l'heure du temps d'acceuil)
            else {
                pointageDepart.setTempsFin(seance.getEnd_date());
            }
            //On prépare le pointage pour l'envoyer dans la base de données
            pointageDepart.setUsername(currentUser.login);
            pointages.push(pointageDepart)
        }
        // Pointage sur plusieurs Temps d'accueil
        else {
            //Commencer par pointer sur le temps présélectionner si le pointage depart est autorisé
            //
            let allowed = state.pointageEnCours.find((pointage: any) =>
                pointage.idIndividu === ind.getId() &&
                pointage.tempsDebut !== "" &&
                pointage.tempsFin === "" &&
                utils
                    .getDateFromString(pointage.tempsDebut, "YYYY-MM-DD HH:mm:ss")
                    .format("YYYY-MM-DD HH:mm:ss") <=
                utils
                    .getDateFromString(seance.getEnd_date(), "YYYY-MM-DD HH:mm:ss")
                    .format("YYYY-MM-DD HH:mm:ss")
            );
            if (allowed !== undefined) {
                if (seance.getHeure_debut_fixe())
                    pointage.setTempsDebut(now.format('YYYY-MM-DD') + " " + seance.getHeure_debut_fixe() + ":00");
                else
                    pointage.setTempsDebut(seance.getStart_date());
                if (seance.getHeure_fin_fixe())
                    pointage.setTempsFin(now.format('YYYY-MM-DD') + " " + seance.getHeure_fin_fixe() + ":00");
                else if (
                    now.isBetween(
                        utils.getDateFromString(seance.getStart_date(), "YYYY-MM-DD HH:mm:ss"),
                        utils.getDateFromString(seance.getEnd_date(), "YYYY-MM-DD HH:mm:ss")
                    ))
                    pointage.setTempsFin(now.format('YYYY-MM-DD HH:mm:ss'));
                else
                    pointage.setTempsFin(seance.getEnd_date());
                pointage.setDatePointage(now.format('YYYYMMDD'));
                let inscription = ind.getInscriptionActivite(currentActiviteId);
                if (typeof inscription !== 'undefined' && inscription) {
                    pointage.setIdInscription(inscription.getId());
                    if (rootGetters.getCurrentActivite.isGroupes()) {
                        pointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                    } else {
                        pointage.setGroupeId(-1)
                    }

                } else {
                    reject("InscriptionNotFound")
                }
                pointage.setTypePointage("REEL");
                pointage.setIdIndividu(ind.getId());
                pointage.setElementFriseId(seance.getFriseElement_id());
                pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + seance.getFriseElement_id() + ind.getId());
                previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && item.individu_id === ind.getId());
                pointage.setIsInoe(false);
                pointage.setUsername(currentUser.login);
                if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
                    pointage.setPaletteId(previ.palette_id);
                } else {
                    pointage.setPaletteId(palette.getId());
                }
                pointages.push(pointage)
            }

            //récuperer toutes les seances qui se trouvé avant le départ pour les pointer (si elles existent)
            let seances = getters.getListTempsAccueil.filter((temps: TarifEventSchedulerActiviteDocument) => {
                return temps.getResource_id() === "AC" &&
                    utils.getDateFromString(temps.getEnd_date(), "YYYY-MM-DD HH:mm:ss") < utils.getDateFromString(seance.getEnd_date(), "YYYY-MM-DD HH:mm:ss")
            })

            // pour vérifier si le pointage existe déjà dans l'une des seances (Pour éviter les conflits dans la BDD)
            let alreadyExist: boolean = true
            seances.forEach((temps: TarifEventSchedulerActiviteDocument) => {
                getters.getPointageEnCours.forEach((pointageEnCours: Pointage) => {
                    if (
                        pointageEnCours.getElementFriseId() === temps.getFriseElement_id() &&
                        pointageEnCours.getIdIndividu() === params[1].id &&
                        pointageEnCours.getTempsFin() === ""
                    ) {
                        if (temps.getHeure_fin_fixe())
                            pointageEnCours.setTempsFin(now.format('YYYY-MM-DD') + " " + temps.getHeure_fin_fixe() + ":00");
                        else
                            pointageEnCours.setTempsFin(temps.getEnd_date())
                        pointageEnCours.setUsername(currentUser.login);
                        pointages.push(pointageEnCours)
                        alreadyExist = false
                    }
                });
                if (!alreadyExist) {
                    pointage = new Pointage({})
                    let inscription = ind.getInscriptionActivite(currentActiviteId);
                    if (typeof inscription !== 'undefined' && inscription) {
                        pointage.setIdInscription(inscription.getId());
                        if (rootGetters.getCurrentActivite.isGroupes()) {
                            pointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                        } else {
                            pointage.setGroupeId(-1)
                        }

                    } else {
                        reject("InscriptionNotFound")
                    }
                    if (temps.getHeure_debut_fixe())
                        pointage.setTempsDebut(now.format('YYYY-MM-DD') + " " + temps.getHeure_debut_fixe() + ":00");
                    else
                        pointage.setTempsDebut(temps.getStart_date());
                    if (temps.getHeure_fin_fixe())
                        pointage.setTempsFin(now.format('YYYY-MM-DD') + " " + temps.getHeure_fin_fixe() + ":00");
                    else
                        pointage.setTempsFin(temps.getEnd_date());
                    pointage.setDatePointage(now.format('YYYYMMDD'));
                    pointage.setTypePointage("REEL");
                    pointage.setIdIndividu(ind.getId());
                    pointage.setElementFriseId(temps.getFriseElement_id());
                    pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + temps.getFriseElement_id() + ind.getId());
                    pointage.setIsInoe(false);
                    pointage.setUsername(currentUser.login);
                    previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && item.individu_id === ind.getId());

                    if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
                        pointage.setPaletteId(previ.palette_id);
                    } else {
                        pointage.setPaletteId(palette.getId());
                    }

                    pointages.push(pointage)
                }

            });

        }
        //Retirer les possibles doublons
        pointages = pointages.filter((thing, index, self) =>
            index === self.findIndex((t) => (
                t.get_id() === thing.get_id()
            )))
        //Envoyer les pointages dans la base de données
        if (pointages.length === 1)
            api.pointagesController.pointer(pointages[0]).then((rep: any) => {
                rep.ok ? resolve("Success") : reject("")
                dispatch("fetchListPointages")
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })
        else
            api.pointagesController.pointageMasse(pointages).then((rep: any) => {
                console.log("BULKADD", rep)
                rep.length === 0 ? resolve("Success") : reject("")
                dispatch("fetchListPointages")
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })

    })
};
/**
 * Créer un pointage départ global
 * @param params [ "arrivée"|"départ", TarifEventSchedulerActiviteDocument, "DateTime" ]
 */
export const addPointageDepartGlobal: Action<PointageState, RootState> = ({ getters, dispatch, commit, rootGetters, state }, params) => {
    return new Promise((resolve, reject) => {
        let seance: TarifEventSchedulerActiviteDocument = params[1];
        let listind: Array<Individu> = Array.from(rootGetters.getFiltredListIndividus);
        let pointages: Array<Pointage> = []
        let splitedDate = (rootGetters.getDate as string).split('-');
        let now = utils.getCurrentTimeNow(splitedDate[0], splitedDate[1], splitedDate[2]);
        let pointage: Pointage
        let pointageDepart: Pointage | undefined
        let palette: PaletteDocument = state.paletteEncours;
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        let lastPointages: any = []
        let currentUser = rootGetters.getCurrentUser;
        let listPrevi = state.listPointagesPrevi;
        let previ: any;

        getters.getPointageEnCours.forEach((element: Pointage) => {
            let p = new Pointage(element)
            lastPointages.push(p)
        });
        let lastaction = {
            name: "PointageGlobalDepart",
            value: lastPointages
        }
        commit(s.SET_LAST_ACTION, lastaction);
        listind.forEach((ind: Individu) => {
            pointage = new Pointage({});
            pointageDepart = state.pointageEnCours.find((item: any) =>
                item.elementFriseId === seance.getFriseElement_id()
                && item.idIndividu === ind.getId()
                && item.tempsFin === "")
            //Pointage départ simple
            if (pointageDepart !== undefined) {
                pointageDepart.setTempsFin(params[2]);
                //On prépare le pointage pour l'envoyer dans la base de données
                pointageDepart.setUsername(currentUser.login);
                pointages.push(pointageDepart)
            }
            // Pointage sur plusieurs Temps d'accueil
            else {
                //Commencer par pointer sur le temps présélectionner si le pointage depart est autorisé
                //
                let allowed = false;
                state.pointageEnCours.forEach((pointage: any) => {
                    if (
                        pointage.idIndividu === ind.getId() &&
                        pointage.tempsDebut !== "" &&
                        pointage.tempsFin === "" &&
                        utils
                            .getDateFromString(pointage.tempsDebut, "YYYY-MM-DD HH:mm:ss")
                            .format("YYYY-MM-DD HH:mm:ss") <=
                        utils
                            .getDateFromString(seance.getEnd_date(), "YYYY-MM-DD HH:mm:ss")
                            .format("YYYY-MM-DD HH:mm:ss")
                    )
                        allowed = true;
                    else if (
                        pointage.idIndividu === ind.getId() &&
                        pointage.tempsFin !== "" &&
                        pointage.tempsDebut === "" &&
                        utils
                            .getDateFromString(pointage.tempsDebut, "YYYY-MM-DD HH:mm:ss")
                            .format("YYYY-MM-DD HH:mm:ss") >
                        utils
                            .getDateFromString(seance.getStart_date(), "YYYY-MM-DD HH:mm:ss")
                            .format("YYYY-MM-DD HH:mm:ss")
                    )
                        allowed = false;
                });
                //
                if (allowed) {
                    if (seance.getHeure_debut_fixe())
                        pointage.setTempsDebut(now.format('YYYY-MM-DD') + " " + seance.getHeure_debut_fixe() + ":00");
                    else
                        pointage.setTempsDebut(seance.getStart_date());
                    pointage.setTempsFin(params[2]);
                    pointage.setDatePointage(now.format('YYYYMMDD'));
                    let inscription = ind.getInscriptionActivite(currentActiviteId);
                    if (typeof inscription !== 'undefined' && inscription) {
                        pointage.setIdInscription(inscription.getId());
                        if (rootGetters.getCurrentActivite.isGroupes()) {
                            pointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                        } else {
                            pointage.setGroupeId(-1)
                        }

                    } else {
                        reject("InscriptionNotFound")
                    }
                    pointage.setTypePointage("REEL");
                    pointage.setIdIndividu(ind.getId());
                    pointage.setElementFriseId(seance.getFriseElement_id());
                    pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + seance.getFriseElement_id() + ind.getId());
                    pointage.setIsInoe(false);
                    pointage.setUsername(currentUser.login);
                    previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && item.individu_id === ind.getId());

                    if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
                        pointage.setPaletteId(previ.palette_id);
                    } else {
                        pointage.setPaletteId(palette.getId());
                    }
                    pointages.push(pointage)
                }

                //récuperer toutes les seances qui se trouvé avant le départ pour les pointer (si elles existent)
                let seances = getters.getListTempsAccueil.filter((temps: TarifEventSchedulerActiviteDocument) => {
                    return temps.getResource_id() === "AC" &&
                        utils.getDateFromString(temps.getEnd_date(), "YYYY-MM-DD HH:mm:ss") < utils.getDateFromString(seance.getEnd_date(), "YYYY-MM-DD HH:mm:ss")
                })

                // pour vérifier si le pointage existe déjà dans l'une des seances (Pour éviter les conflits dans la BDD)
                let alreadyExist: boolean = true
                seances.forEach((temps: TarifEventSchedulerActiviteDocument) => {
                    getters.getPointageEnCours.forEach((pointageEnCours: Pointage) => {
                        if (
                            pointageEnCours.getElementFriseId() === temps.getFriseElement_id() &&
                            pointageEnCours.getIdIndividu() === ind.getId() &&
                            pointageEnCours.getTempsFin() === ""
                        ) {
                            if (temps.getHeure_fin_fixe())
                                pointageEnCours.setTempsFin(now.format('YYYY-MM-DD') + " " + temps.getHeure_fin_fixe() + ":00");
                            else
                                pointageEnCours.setTempsFin(temps.getEnd_date())
                            pointageEnCours.setUsername(currentUser.login);
                            pointages.push(pointageEnCours)
                            alreadyExist = false
                        }
                    });
                    if (!alreadyExist) {
                        pointage = new Pointage({})
                        let inscription = ind.getInscriptionActivite(currentActiviteId);
                        if (typeof inscription !== 'undefined' && inscription) {
                            pointage.setIdInscription(inscription.getId());
                            if (rootGetters.getCurrentActivite.isGroupes()) {
                                pointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                            } else {
                                pointage.setGroupeId(-1)
                            }

                        } else {
                            reject("InscriptionNotFound")
                        }
                        if (temps.getHeure_debut_fixe())
                            pointage.setTempsDebut(now.format('YYYY-MM-DD') + " " + temps.getHeure_debut_fixe() + ":00");
                        else
                            pointage.setTempsDebut(temps.getStart_date());
                        if (temps.getHeure_fin_fixe())
                            pointage.setTempsFin(now.format('YYYY-MM-DD') + " " + temps.getHeure_fin_fixe() + ":00");
                        else
                            pointage.setTempsFin(temps.getEnd_date());
                        pointage.setDatePointage(now.format('YYYYMMDD'));
                        pointage.setTypePointage("REEL");
                        pointage.setIdIndividu(ind.getId());
                        pointage.setElementFriseId(temps.getFriseElement_id());
                        pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + temps.getFriseElement_id() + ind.getId());
                        pointage.setIsInoe(false);
                        pointage.setUsername(currentUser.login);
                        previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && item.individu_id === ind.getId());

                        if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
                            pointage.setPaletteId(previ.palette_id);
                        } else {
                            pointage.setPaletteId(palette.getId());
                        }
                        pointages.push(pointage)
                    }
                });
            }
        });
        //Envoyer les pointages dans la base de données
        api.pointagesController.pointageMasse(pointages).then((rep: any) => {
            console.log("BULKADD", rep)
            rep.length === 0 ? resolve("Success") : reject("")
            dispatch("fetchListPointages")
        }).catch((e: any) => {
            console.error(e)
            router.push("/erreurs/" + e);
        })
    })
};

/**
 * Modifier un pointage départ où arrivée
 * @param params [ "arrivée"|"départ", "DateTime", Pointage ]
 */
export const editPointage: Action<PointageState, RootState> = ({ rootGetters }, params) => {
    return new Promise((resolve, reject) => {
        let currentUser = rootGetters.getCurrentUser;
        let pointage: Pointage = params[1]
        if (params[0] === "arrivée") {
            pointage.setTempsDebut(params[2])
        } else if (params[0] === "départ") {
            pointage.setTempsFin(params[2])
        } else {
            reject("")
        }
        if (pointage.getUsername() === "")
            pointage.setUsername(currentUser.login)
        api.pointagesController.pointer(pointage).then((rep: any) => {
            rep.ok ? resolve("Success") : reject("")
        }).catch((e: any) => {
            console.error(e)
            router.push("/erreurs/" + e);
        })
    })
};

/**
 * Effacer un pointage départ où arrivée
 * @param params [ Pointage, "arrivée"|"départ" ]
 */
export const removePointage: Action<PointageState, RootState> = ({ dispatch }, params) => {
    return new Promise((resolve, reject) => {
        let pointage: Pointage = params[0];
        if (params[1] === 'départ' && pointage.getTempsDebut() !== "") {
            pointage.setTempsFin('')
        } else {
            pointage.set_deleted(true);
        }
        api.pointagesController.pointer(pointage).then((rep: any) => {
            rep.ok ? resolve("Success") : reject("")
            dispatch("fetchListPointages")
        }).catch((e: any) => {
            console.error(e)
            router.push("/erreurs/" + e);
        })
    })
};

/**
 * Effacer une liste de pointages départ où arrivée
 * @param params [ TarifEventSchedulerActiviteDocument, "arrivée"|"départ" ]
 */
export const removeAllPointages: Action<PointageState, RootState> = ({ getters, dispatch,rootGetters }, params) => {
    return new Promise((resolve, reject) => {
        let seance: TarifEventSchedulerActiviteDocument = params[0];
        let listind: Array<Individu> = Array.from(rootGetters.getFiltredListIndividus);
        let pointages: Array<Pointage>
        const listindsIds =  listind.map((i:any)=> {return i.getId()})
        if (params[1] === 'départ') {
            pointages = getters.getPointageEnCours.filter((pointage: Pointage) => {
                return listindsIds.includes(pointage.getIdIndividu()) && seance.getFriseElement_id() === pointage.getElementFriseId()
                    && pointage.getTempsFin() !== ""
                    && !pointage.isIsInoe()
            })
            pointages.forEach((pointage: Pointage) => {
                if(listindsIds.includes(pointage.getIdIndividu())) pointage.setTempsFin('')
            });
            api.pointagesController.pointageMasse(pointages).then((rep: any) => {
                console.log("BULKDUPDATED", rep)
                rep.length === 0 ? resolve("Success") : reject("")
                dispatch("fetchListPointages")
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })
        } else if(params[1] === 'arrivée'){
            pointages = getters.getPointageEnCours.filter((pointage: Pointage) => {
                return listindsIds.includes(pointage.getIdIndividu()) && seance.getFriseElement_id() === pointage.getElementFriseId()
                    && !pointage.isIsInoe()

            })
            pointages.forEach((pointage: Pointage) => {
                if(listindsIds.includes(pointage.getIdIndividu())) pointage.set_deleted(true);
            });
            api.pointagesController.pointageMasse(pointages).then((rep: any) => {
                console.log("BULKDELETE", rep)
                rep.length === 0 ? resolve("Success") : reject("")
                dispatch("fetchListPointages")
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })
        }

    })
};

/**
 * Créer un pointage temps supplémentaire
 * @param params [ TarifEventSchedulerActiviteDocument, Individu ]
 */
export const addPointageTS: Action<PointageState, RootState> = ({ dispatch, state, rootGetters }, params) => {
    return new Promise((resolve, reject) => {
        let seance: TarifEventSchedulerActiviteDocument = params[0];
        let Individu: Individu = params[1]
        let pointage = new Pointage({});
        let now = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let palette: PaletteDocument = state.paletteEncours;
        let currentActivite = rootGetters.getCurrentActivite as Activite
        let currentActiviteId = currentActivite.getId();
        let currentUser = rootGetters.getCurrentUser;

        let inscription = Individu.getInscriptionActivite(currentActiviteId);
        if (typeof inscription !== 'undefined' && inscription) {
            pointage.setIdInscription(inscription.getId());
            if (rootGetters.getCurrentActivite.isGroupes()) {
                let date: string = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
                pointage.setGroupeId(inscription.getHistoGroupe(date).getGroupeActivite().getId())

            } else {
                pointage.setGroupeId(-1)
            }

        } else {
            reject("InscriptionNotFound")
        }
        pointage.setTempsDebut(seance.getStart_date());
        pointage.setTempsFin(seance.getEnd_date());
        pointage.setDatePointage(now.format('YYYYMMDD'));
        pointage.setTypePointage("REEL");
        pointage.setIdIndividu(Individu.getId());
        pointage.setTempsSupplementaireId(seance.getTempsTarif_id());
        pointage.setTempsSupplementaireIntitule(seance.getPlageIntitule());
        pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + seance.getTempsTarif_id() + Individu.getId());
        pointage.setPaletteId(palette.getId());
        pointage.setIsInoe(false);
        pointage.setUsername(currentUser.login);
        /* Call API */
        api.pointagesController.pointer(pointage).then((rep: any) => {
            console.log("ADD", rep)
            rep.ok ? resolve("Success") : reject("")
            dispatch("fetchListPointages")
        }).catch((e: any) => {
            console.error(e)
            router.push("/erreurs/" + e);
        })

    })
};

/**
 * Effacer un pointage temps supplémentaire
 * @param params Pointage
 */
export const removePointageTS: Action<PointageState, RootState> = ({ dispatch }, pointage) => {
    return new Promise((resolve, reject) => {
        pointage.set_deleted(true);
        api.pointagesController.pointer(pointage).then((rep: any) => {
            rep.ok ? resolve("Success") : reject("")
            dispatch("fetchListPointages")
        }).catch((e: any) => {
            console.error(e)
            router.push("/erreurs/" + e);
        })

    })
};

/**
 * Créer un pointage temps supplémentaire global
 * @param params TarifEventSchedulerActiviteDocument
 */
export const pointageTSGlobal: Action<PointageState, RootState> = ({ rootGetters, getters, dispatch, state, commit }, params) => {
    return new Promise((resolve, reject) => {
        let seance: TarifEventSchedulerActiviteDocument = params;
        let listind: Array<Individu> = Array.from(rootGetters.getFiltredListIndividus);
        let now = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let listpointage: Array<Pointage> = [];
        let palette: PaletteDocument = state.paletteEncours;
        let currentActivite = rootGetters.getCurrentActivite as Activite
        let currentActiviteId = currentActivite.getId();
        let currentUser = rootGetters.getCurrentUser;
        //Recup pointage actif
        let pointageactif = getters.getPointageEnCours as Array<Pointage>;
        //Filtrer selon la séance
        let pointageActifTemps: Array<Pointage> = pointageactif.filter(
            (item: any) => {
                if (
                    item.getElementFriseId() === seance.getFriseElement_id() ||
                    item.getTempsSupplementaireId() === seance.getTempsTarif_id()
                ) {
                    return item;
                }
            }
        ) as Array<Pointage>;
        //Retirer les enfants déja pointer
        pointageActifTemps.forEach((pointage: Pointage) => {
            let i: any = listind.findIndex(
                enfant => enfant.getId() === pointage.getIdIndividu()
            );
            listind.splice(i, 1);
        });
        //Si tous les enfants sont pointer, donc supp pointages
        if (listind.length === 0) {
            listind = Array.from(rootGetters.getFiltredListIndividus);
            pointageActifTemps.forEach((pointage: Pointage) => {
                if (!pointage.isIsInoe())
                    pointage.set_deleted(true);
            });
            let lastaction = {
                name: "Suppression Pointage Temps supplémentaires",
                value: pointageActifTemps
            }
            commit(s.SET_LAST_ACTION, lastaction);
            api.pointagesController.pointageMasse(pointageActifTemps).then((rep: any) => {
                console.log("BULKDELETE", rep)
                rep.length === 0 ? resolve("Success") : reject("")
                dispatch("fetchListPointages")
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })
        } else {
            listind.forEach((ind: Individu) => {
                let pointage = new Pointage({});

                let inscription = ind.getInscriptionActivite(currentActiviteId);
                if (typeof inscription !== 'undefined' && inscription) {
                    pointage.setIdInscription(inscription.getId());
                    if (rootGetters.getCurrentActivite.isGroupes()) {
                        let date: string = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
                        pointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                    } else {
                        pointage.setGroupeId(-1)
                    }

                } else {
                    reject("InscriptionNotFound")
                }
                pointage.setTempsDebut(seance.getStart_date());
                pointage.setTempsFin(seance.getEnd_date());
                pointage.setDatePointage(now.format('YYYYMMDD'));
                pointage.setTypePointage("REEL");
                pointage.setIdIndividu(ind.getId());
                pointage.setTempsSupplementaireId(seance.getTempsTarif_id());
                pointage.setTempsSupplementaireIntitule(seance.getPlageIntitule());
                pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + seance.getTempsTarif_id() + ind.getId());
                pointage.setPaletteId(palette.getId());
                pointage.setIsInoe(false);
                pointage.setUsername(currentUser.login);
                listpointage.push(pointage);
            });
            let lastaction = {
                name: "Pointage Temps supplémentaires",
                value: listpointage
            }
            commit(s.SET_LAST_ACTION, lastaction);
            api.pointagesController.pointageMasse(listpointage).then((rep: any) => {
                console.log("BULKADD", rep)
                rep.length === 0 ? resolve("Success") : reject("")
                dispatch("fetchListPointages")
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })

        }
    })
};

/**
 * Récuperer liste des pointages prévisionnels
 */
export const fetchPointagePrevi: Action<PointageState, RootState> = ({ commit, getters, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let currentActivite = rootGetters.getCurrentActivite as Activite;
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let paletteAbsenceId: Array<number> = getters.getListPaletteAbsence.map((palette: PaletteDocument) => palette.getId());
        commit(s.SET_POINTAGE_PREVI, currentActivite.getPointagePrévi(currentDate.format('YYYY-MM-DD'), paletteAbsenceId));
        resolve("fetchpointageprevi done");
    })
};
/**
 * Changer la palette
 * @params PaletteDocument
 */
export const setPaletteEncours: Action<PointageState, RootState> = ({ commit }, params: PaletteDocument) => {
    commit(s.SET_PALETTE_ENCOURS, params)
};

export const fetchListSupplement: Action<PointageState, RootState> = ({ rootGetters, commit }) => {
    return new Promise((resolve, reject) => {
        commit(s.SET_LIST_SUPPLEMENTS, []);

        let currentActivite = rootGetters.getCurrentActivite as Activite;
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");

        let listSupplement = currentActivite.getSupplements(currentDate.format('YYYY-MM-DD'));
        commit(s.SET_LIST_SUPPLEMENTS, listSupplement);
        commit(s.SET_LIST_SUPPLEMENTS_FILTRED, listSupplement);

        resolve('listsupplement done')
    })
};


export const fetchSupplementActifs: Action<PointageState, RootState> = ({ commit, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        api.pointagesController.listSupplementsActifs(currentDate, currentActiviteId).then((rep: Array<Supplement>) => {
            commit(s.SET_SUPPLEMENTS_ACTIFS, rep)
            resolve("supplementactif done")
        })

    })
};

/**
 * Annuler la dérniere action
 */
export const undoLastAction: Action<PointageState, RootState> = ({ state, getters, dispatch, commit }) => {
    return new Promise((resolve, reject) => {
        let lastaction = state.lastAction;
        let pointageactif = getters.getPointageEnCours as Array<Pointage>;
        let docs: any
        switch (lastaction.name) {
            case 'Pointage Temps supplémentaires':
            case 'PointageGlobalArrive':
                {

                    pointageactif = pointageactif.filter((pointage: Pointage) => {
                        if (lastaction.value.some((element: Pointage) => pointage.get_id() === element.get_id())) {
                            return pointage;
                        }
                    })
                    pointageactif.forEach((element: Pointage) => {
                        element.set_deleted(true);
                    });
                    docs = pointageactif
                    break;
                }
            case 'PointageGlobalDepart':
                {
                    let exist: boolean
                    pointageactif.forEach((pointage: Pointage) => {
                        exist = false
                        lastaction.value.forEach((pointageVal: Pointage) => {
                            if (pointage.get_id() === pointageVal.get_id()) {
                                exist = true
                                pointage.setTempsFin(pointageVal.getTempsFin())
                            }
                        });
                        if (!exist) pointage.set_deleted(true)

                    });
                    docs = pointageactif
                    break;
                }
            case 'SupplementMasse':
                {
                    let suppActif = getters.getSupplementsActifs as Array<Supplement>;
                    suppActif = suppActif.filter((supplement: Supplement) => {
                        if (lastaction.value.some((element: Supplement) => supplement.get_id() === element.get_id())) {
                            return supplement;
                        }
                    })
                    suppActif.forEach((element: Supplement) => {
                        element.set_deleted(true);
                    });
                    docs = suppActif;
                    break;
                }
            case 'Suppression Pointage Temps supplémentaires':
            case 'SuppressionMasse':
                {
                    lastaction.value.forEach((element: any) => {
                        element.set_deleted(false);
                    });
                    docs = lastaction.value
                    break;
                }
            default:
                break;
        }
        if (lastaction.name !== 'NoAction') {
            console.log("Undo Last Action", lastaction)
            api.pointagesController.updateDocument(docs).then((rep: any) => {
                rep.ok ? resolve("Success") : reject("")
                commit(s.SET_LAST_ACTION, {
                    name: "NoAction",
                    value: "NoValue"
                })
                Promise.all([dispatch("fetchSupplementActifs"), dispatch("fetchListPointages")]);
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })
        }

    })
};


/**
 * Confirmer tout les pointages prévisionnels 
 * @param params [ Array<idTempsAccueil>, Array<idSupplement> ]
 */
export const confReservation: Action<PointageState, RootState> = ({ dispatch }, params: Array<any>) => {
    return new Promise((resolve, reject) => {
        let listPromise: Array<Promise<any>> = [];
        listPromise.push(dispatch('confReservationPointage', params[0]));
        listPromise.push(dispatch('confReservationSupplements', params[1]));

        Promise.all(listPromise).then((rep: any) => {
            console.warn("conf-reserve", rep);
            if (rep[0] !== "NoPreviFound" || rep[1] !== "NoPreviFound") {
                resolve("confreservation done");
            } else {
                router.push("/erreurs/no-previsionnel")
                reject('no-previsionnel')
            }

        });

    })
};

/**
 * Confirmer tout les suppléments prévisionnels 
 * @param params Array<dSupplement>
 */
export const confReservationSupplements: Action<PointageState, RootState> = ({ state, dispatch, rootGetters }, params: Array<number>) => {
    return new Promise((resolve, reject) => {
        let listSupplementsPointer: Array<Supplement> = [];

        let listSupplementsActifs: Array<string> = state.listSupplementsActifs.map((supp: Supplement) => supp.get_id());
        let listSupplements: Array<TarifActiviteDocument> = state.listSupplements;
        let listind: Array<Individu> = Array.from(rootGetters.getFiltredListIndividus);
        let now = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        let currentUser = rootGetters.getCurrentUser;

        //Recup les Supppléments filtrer depuis Params
        let listSuppParams: Array<TarifActiviteDocument> = listSupplements.filter((supp: TarifActiviteDocument) => params.includes(supp.getId()));
        //Recup les supplements prévisionnel
        let listPrevi = state.listSupplementsPrevi;
        //Filtrer la liste
        listPrevi = listPrevi.filter((item: any) => listSuppParams.some(supp => supp.getId() === item.supplement_id && !supp.isIsAuto()));
        if (listPrevi.length != 0) {
            listPrevi.forEach((supp: any) => {
                let ind: Individu | undefined = listind.find((individu: Individu) => individu.getId() === supp.individu_id);
                let supplement: TarifActiviteDocument | undefined = listSupplements.find((s: TarifActiviteDocument) => s.getId() === supp.supplement_id);

                if (typeof ind !== 'undefined' && typeof supplement !== 'undefined') {
                    let s = new Supplement({});

                    s.set_id("supplementAN" + now.format('YYYYMMDD') + currentActiviteId + supplement.getId() + ind.getId());
                    s.setChecked(true);
                    s.setFactureEnAttente(false);
                    let inscription = ind.getInscriptionActivite(currentActiviteId);
                    if (typeof inscription !== 'undefined' && inscription) {
                        s.setInscriptionId(inscription.getId());


                    } else {
                        reject("InscriptionNotFound")
                    }
                    s.setIntitule(supplement.getPlageIntitule());
                    s.setIsFacture(false);
                    s.setModifieApresFacture(false);
                    s.setNomEnfant(ind.getDisplayName());
                    s.setOrdreListeAttente(0);
                    s.setPointageDate(now.format('YYYY-MM-DDTHH:mm:ss'));
                    s.setSupplementId(supplement.getId());
                    s.setTelephone('');
                    s.setTooltipNumFacture('');
                    s.setTypePointage('REEL');
                    s.setTypeSupplement('SU');
                    s.setVersion(0);
                    s.setIsInoe(false);
                    s.setUsername(currentUser.login);
                    listSupplementsPointer.push(s);
                } else {
                    reject('NoIndWithPrevi')
                }
            });

            //On retire les pointages existants
            listSupplementsPointer = listSupplementsPointer.filter((suppl: Supplement) => !listSupplementsActifs.includes(suppl.get_id()));
            api.pointagesController.supplementMasse(listSupplementsPointer).then((rep: any) => {
                console.log("SupplementMasse", rep)
                rep.length === 0 ? resolve("Success") : reject("")
                dispatch("fetchSupplementActifs")
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })
        } else {
            resolve('NoPreviFound')
        }


    })
}
/**
 * Confirmer tout les pointages prévisionnels 
 * @param params Array<idPointage>
 */
export const confReservationPointage: Action<PointageState, RootState> = ({ state, dispatch, commit, rootGetters }, params: Array<number>) => {
    return new Promise((resolve, reject) => {
        let listPointage: Array<Pointage> = [];

        let listPointageActifs: Array<string> = state.pointageEnCours.map((pointage: Pointage) => pointage.get_id());
        let listSeance: Array<TarifEventSchedulerActiviteDocument> = state.listTempsAccueil;
        let palette: PaletteDocument = state.paletteEncours;
        let listind: Array<Individu> = Array.from(rootGetters.getFiltredListIndividus);
        let now = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        let currentUser = rootGetters.getCurrentUser;
        //Recup Temps filtrer depuis Params
        let listSeanceParams: Array<TarifEventSchedulerActiviteDocument> = listSeance.filter((seance: TarifEventSchedulerActiviteDocument) => params.includes(seance.getId()));

        //Recup les pointages prévisionnel
        let listPrevi = state.listPointagesPrevi;
        //Filtrer la liste
        listPrevi = listPrevi.filter((item: any) => {
            if (
                (typeof item.elementfrise_id !== 'undefined' &&
                    listSeanceParams.some(seance => seance.getFriseElement_id() === item.elementfrise_id))
                ||
                (typeof item.tariftempssupplactivite_id !== 'undefined' &&
                    listSeanceParams.some(seance => seance.getTempsTarif_id() === item.tariftempssupplactivite_id))
            ) {
                return item;
            }
        });

        if (listPrevi.length != 0) {
            listPrevi.forEach(temps => {
                let ind: Individu | undefined = listind.find((individu: Individu) => individu.getId() === temps.individu_id);
                if (typeof ind !== 'undefined') {
                    let pointage = new Pointage({});
                    let seance: any;
                    let inscription = ind.getInscriptionActivite(currentActiviteId);
                    if (typeof inscription !== 'undefined' && inscription) {
                        pointage.setIdInscription(inscription.getId());
                        if (rootGetters.getCurrentActivite.isGroupes()) {
                            pointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                        } else {
                            pointage.setGroupeId(-1)
                        }

                    } else {
                        reject("InscriptionNotFound")
                    }
                    if (typeof temps.elementfrise_id !== 'undefined') {
                        seance = listSeance.find((s: TarifEventSchedulerActiviteDocument) => s.getFriseElement_id() === temps.elementfrise_id);
                        pointage.setElementFriseId(seance.getFriseElement_id());
                        pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + seance.getFriseElement_id() + ind.getId());
                    }
                    if (typeof temps.tariftempssupplactivite_id !== 'undefined') {
                        seance = listSeance.find((s: TarifEventSchedulerActiviteDocument) => s.getTempsTarif_id() === temps.tariftempssupplactivite_id);
                        pointage.setTempsSupplementaireId(seance.getTempsTarif_id());
                        pointage.setTempsSupplementaireIntitule(seance.getPlageIntitule());
                        pointage.set_id("pointageAN" + now.format('YYYYMMDD') + currentActiviteId + seance.getTempsTarif_id() + ind.getId());
                    }
                    //On rajoute les suppléments Non Automatique pointage.setTempsDebut(seance.getStart_date());
                    pointage.setTempsDebut(seance.getStart_date());
                    pointage.setTempsFin(seance.getEnd_date());
                    pointage.setDatePointage(now.format('YYYYMMDD'));
                    pointage.setTypePointage("REEL");
                    pointage.setIdIndividu(ind.getId());
                    pointage.setUsername(currentUser.login);
                    if (temps.palette_id === -31)
                        pointage.setPaletteId(-32);
                    else
                        pointage.setPaletteId(temps.palette_id);
                    pointage.setIsInoe(false);
                    listPointage.push(pointage)
                } else {
                    reject('NoIndWithPrevi')
                }
            });
            //On retire les pointages existants
            listPointage = listPointage.filter((pointage: Pointage) => !listPointageActifs.includes(pointage.get_id()))

            api.pointagesController.pointageMasse(listPointage).then((rep: any) => {
                console.log("PointageMasse", rep)
                rep.length === 0 ? resolve("Success") : reject("")
                dispatch("fetchListPointages")
            }).catch((e: any) => {
                console.error(e)
                router.push("/erreurs/" + e);
            })
        } else {
            resolve('NoPreviFound')
        }

    })
};

/* ############### POINTAGE TEMPS ############### */
export const fetchAll: Action<PointageState, RootState> = ({ dispatch, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let listPromise: Array<Promise<any>> = [];
        dispatch("fetchListPointages").then(() => {
            dispatch('fetchSupplementActifs').then(() => {
                listPromise.push(dispatch("fetchPalette"));
                listPromise.push(dispatch("fetchGroupes"));
                listPromise.push(dispatch("fetchRegim"));
                listPromise.push(dispatch("fetchListTempsAccueil"));
                listPromise.push(dispatch('fetchListSupplement'));
                listPromise.push(dispatch("fetchPointagePrevi"));
                listPromise.push(dispatch("fetchPointageReel"));
                listPromise.push(dispatch('fetchSuppPrévi'));
                listPromise.push(dispatch('fetchSuppReel'));
                listPromise.push(dispatch('resetLastAction'));
                listPromise.push(dispatch('fetchVieQuoRegimeAli'));
                listPromise.push(dispatch('removeDeletedPointages'));
                listPromise.push(dispatch('removeDeletedSupplements'));
                listPromise.push(dispatch('setPaletteEncours', new PaletteDocument({})));
                Promise.all(listPromise).then((rep: any) => {
                    resolve('promiseall done')
                }).catch((error: any) => {
                    console.log("error", error)
                    reject(error)
                })
            })
        })

    })
};
export const fetchPointageReel: Action<PointageState, RootState> = ({ commit, getters, rootGetters, dispatch }) => {
    return new Promise((resolve, reject) => {
        let currentActivite = rootGetters.getCurrentActivite;
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let listPointageMobi = Array.from(getters.getPointageEnCours) as Array<Pointage>;
        let listPointageInoe = (currentActivite as Activite).getPointageRéel(currentDate.format('YYYY-MM-DD'));
        let listProm: Array<Promise<any>> = [];
        listPointageInoe.forEach((pointageInoe: Pointage) => {
            let alreadyExist = false;
            let doublon = listPointageMobi.find((pointageMobi: Pointage) => pointageMobi.get_id() === pointageInoe.get_id());
            if (typeof doublon !== 'undefined') {
                pointageInoe.set_rev(doublon.get_rev());
                alreadyExist = doublon.getUsername() === 'Inoe' && doublon.getPdetail_id() !== -1;
            }
            if (!alreadyExist)
                listProm.push(
                    api.pointagesController.pointer(pointageInoe).then(() => {
                        console.log("Ajout du pointage Inoe")
                        resolve("Success");
                    })
                )
        });
        Promise.all(listProm).then((rep: any) => {
            dispatch("fetchListPointages").then(() => {
                resolve("fetchpointagereel done")
            })
        })
    })
};
export const fetchPalette: Action<PointageState, RootState> = ({ commit, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let currentActivite = rootGetters.getCurrentActivite as Activite;
        let currentEtab = rootGetters.getCurrentEtablissement as Etablissement;
        let PaletteEnfant = new Set(currentEtab.getPalette());
        let PaletteCategorie = new Set(currentActivite.getPalette());
        let listPalette: Array<PaletteDocument> = [];

        PaletteCategorie.forEach((palCat: number) => {
            if (PaletteEnfant.has(palCat)) {
                let palette: PaletteDocument = db.getPalette(palCat);
                if (typeof palette === "undefined") {
                    console.error(`La palette dont ID = ${palCat} est introuvable !`);
                } else {
                    if (!palette.getArchive()) {
                        palette.setCouleurHex(utils.decimalToHexString(palette.getCouleur()));
                        listPalette.push(palette);
                    }
                }
            }
        });

        let paletteDefaut: PaletteDocument = db.getPalette(-32);
        if (typeof paletteDefaut === "undefined") {
            console.error(`La palette dont ID = ${-32} est introuvable !`);
        } else {
            paletteDefaut.setCouleurHex('#00827a');
            listPalette.unshift(paletteDefaut);
        }


        let presence: Array<PaletteDocument> = [];
        let absence: Array<PaletteDocument> = [];
        listPalette.forEach((palette: PaletteDocument) => {
            if (palette.getPresence() === 'PRESENCE' && palette.getTypePointage().includes('REEL')) {
                presence.push(palette);
            }
            if (palette.getPresence() === 'ABSENCE' && palette.getTypePointage().includes('REEL')) {
                absence.push(palette);
            }
        });
        commit(s.SET_LIST_PALETTE_PRESENCE, presence);
        commit(s.SET_LIST_PALETTE_ABSENCE, absence);
        resolve('listpalette done');
    })
};
export const fetchGroupes: Action<PointageState, RootState> = ({ commit, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let listGroupes: Array<GroupeIndividu> = [];
        let currentActivite = rootGetters.getCurrentActivite as Activite;
        currentActivite.getGroupesActivite().forEach((item: number) => {
            listGroupes.push(db.getGroupe(item))
        });
        if (typeof listGroupes !== 'undefined' && Array.isArray(listGroupes))
            commit(s.SET_LIST_GROUPES, listGroupes.sort((a: GroupeIndividu, b: GroupeIndividu) =>
                new Intl.Collator('fr', { usage: "sort" }).compare(a.getintitule(), b.getintitule())));
        resolve('listgroupe done')


    })
};
export const fetchRegim: Action<PointageState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        commit(s.SET_LIST_REGIM, db.getRegimesAlim());
        resolve('listregim done')
    })
};
export const fetchVieQuoRegimeAli: Action<PointageState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        commit(s.SET_VIE_REGIM_ALI, db.getVieQuoRegimeAli());
        resolve('fetchVieQuoRegimeAli done')
    })
};
export const fetchSuppPrévi: Action<PointageState, RootState> = ({ commit, state, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let currentActivite = rootGetters.getCurrentActivite as Activite;
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        commit(s.SET_SUPPLEMENTS_PREVI, currentActivite.getSupplementsPrévi(currentDate.format('YYYY-MM-DD')))
        resolve("suppprevi done")

    })
};
export const fetchSuppReel: Action<PointageState, RootState> = ({ commit, getters, rootGetters, dispatch }) => {
    return new Promise((resolve, reject) => {
        let alreadyExist = false;
        let currentActivite = rootGetters.getCurrentActivite as Activite;
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let listSuppMobi = Array.from(getters.getSupplementsActifs) as Array<Supplement>;
        let listSuppInoe = currentActivite.getSupplementsRéel(currentDate.format('YYYY-MM-DD'));

        let listProm: Array<Promise<any>> = [];
        listSuppInoe.forEach((suppInoe: Supplement) => {
            let doublon = listSuppMobi.find((suppMobi: Supplement) => suppMobi.get_id() === suppInoe.get_id());
            if (typeof doublon !== 'undefined') {
                suppInoe.set_rev(doublon.get_rev());
                alreadyExist = doublon.getUsername() === 'Inoe' && doublon.getPdetail_id() !== -1;
            }
            if (!alreadyExist)
                listProm.push(
                    api.pointagesController.pointer(suppInoe).then((rep: any) => {
                        console.log("Ajout du Supplément Inoe")
                        resolve("Success");
                    })
                );
        });
        Promise.all(listProm).then((rep: any) => {
            dispatch("fetchSupplementActifs").then(() => {
                resolve("fetchSuppReel done")
            })
        })
    })
};
export const pointageTemps: Action<PointageState, RootState> = ({ dispatch, state, rootGetters }, params) => {
    let seance: TarifEventSchedulerActiviteDocument = params[0];
    let ind: Individu = params[1];
    //let now = utils.getCurrentTimeNow();
    let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
    let currentActiviteId = rootGetters.getCurrentActivite.getId();
    let pointageEnCours = state.pointageEnCours.map((pointage: Pointage) =>
        pointage.get_id()
    );
    if (pointageEnCours.includes("pointageAN" + currentDate.format("YYYYMMDD") + currentActiviteId + seance.getFriseElement_id() + ind.getId())
        || pointageEnCours.includes("pointageAN" + currentDate.format("YYYYMMDD") + currentActiviteId + seance.getTempsTarif_id() + ind.getId())
    ) {
        dispatch('removePointageTAC', params);
    } else {
        console.log("AJOUTDE POINTAGE PAR TEMPS D'ACCUEIL !!!")
        dispatch('addPointageTAC', params);
    }
};
export const addPointageTAC: Action<PointageState, RootState> = ({ state, dispatch, commit, rootGetters }, params) => {
    return new Promise((resolve, reject) => {
        let seance: TarifEventSchedulerActiviteDocument = params[0];
        let ind: Individu = params[1];
        //let now = utils.getCurrentTimeNow();
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let palette: PaletteDocument = state.paletteEncours;
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        let currentUser = rootGetters.getCurrentUser;
        let listPrevi = state.listPointagesPrevi;
        let previ: any;

        let pointage = new Pointage({});
        let inscription = ind.getInscriptionActivite(currentActiviteId);
        if (typeof inscription !== 'undefined' && inscription) {
            pointage.setIdInscription(inscription.getId());
            if (rootGetters.getCurrentActivite.isGroupes()) {
                pointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
            } else {
                pointage.setGroupeId(-1)
            }
        } else {
            reject("InscriptionNotFound")
        }
        pointage.setTempsDebut(seance.getStart_date());
        pointage.setTempsFin(seance.getEnd_date());
        pointage.setDatePointage(currentDate.format('YYYYMMDD'));
        pointage.setTypePointage("REEL");
        pointage.setIdIndividu(ind.getId());
        pointage.setIsInoe(false);
        pointage.setUsername(currentUser.login);


        if (seance.getResource_id() === 'AC' || seance.getResource_id() === 'JO') {
            previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && item.individu_id === ind.getId());
            pointage.setElementFriseId(seance.getFriseElement_id());
            pointage.set_id("pointageAN" + currentDate.format('YYYYMMDD') + currentActiviteId + seance.getFriseElement_id() + ind.getId());
        } else {
            previ = listPrevi.find((item: any) => item.tariftempssupplactivite_id === seance.getTempsTarif_id() && item.individu_id === ind.getId());
            pointage.setTempsSupplementaireId(seance.getTempsTarif_id());
            pointage.setTempsSupplementaireIntitule(seance.getPlageIntitule());
            pointage.set_id("pointageAN" + currentDate.format('YYYYMMDD') + currentActiviteId + seance.getTempsTarif_id() + ind.getId());
        }

        if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
            pointage.setPaletteId(previ.palette_id);
        } else {
            pointage.setPaletteId(palette.getId());
        }
        api.pointagesController.pointer(pointage).then((rep: any) => {
            
            commit(s.ADD_POINTAGE_ENCOURD, pointage)

            rep.ok ? resolve("Success") : reject("");
        }).finally(() => {

          //  dispatch("fetchListPointages")
        }).catch((error: any) => {
            reject("FailPointage")
        })
    })
};

export const test: Action<PointageState, RootState> = ({ dispatch, rootGetters }, params) => {

    console.log(12121,params,db.getPointageDetailInoe(params))

}


export const removePointageTAC: Action<PointageState, RootState> = ({ dispatch, rootGetters }, params) => {
    return new Promise((resolve, reject) => {
        let seance: TarifEventSchedulerActiviteDocument = params[0];
        let ind: Individu = params[1];
        let pointageid: string = "";
        //let now = utils.getCurrentTimeNow();
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let currentActiviteId = rootGetters.getCurrentActivite.getId();

        if (seance.getResource_id() === 'AC' || seance.getResource_id() === 'JO') {
            pointageid = "pointageAN" + currentDate.format('YYYYMMDD') + currentActiviteId + seance.getFriseElement_id() + ind.getId();
        } else {
            pointageid = "pointageAN" + currentDate.format('YYYYMMDD') + currentActiviteId + seance.getTempsTarif_id() + ind.getId();
        }
        api.pointagesController.supprimerPointage(pointageid).then((rep: any) => {
            rep.ok ? resolve("Success") : reject("")
        }).finally(() => {
            dispatch("fetchListPointages")
        })
    })
};

export const addPointageMasseAvecTemps: Action<PointageState, RootState> = ({ rootGetters, getters, dispatch, state, commit }, params) => {
    return new Promise((resolve, reject) => {
        let seance: TarifEventSchedulerActiviteDocument = params;
        let listind: Array<Individu> = Array.from(rootGetters.getFiltredListIndividus);
        //let now = utils.getCurrentTimeNow();
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let listpointage: Array<Pointage> = [];
        let palette: PaletteDocument = state.paletteEncours;
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        let currentUser = rootGetters.getCurrentUser;
        let listPrevi = state.listPointagesPrevi;
        let previ: any;

        //Recup pointage actif
        let pointageactif = getters.getPointageEnCours as Array<Pointage>;
        //console.log("pointageactif: ",pointageactif)
        //Filtrer selon la séance
        let pointageActifTemps: Array<Pointage> = pointageactif.filter(
            (item: any) => {
                if (
                    item.getElementFriseId() === seance.getFriseElement_id() ||
                    item.getTempsSupplementaireId() === seance.getTempsTarif_id()
                ) {
                    return item;
                }
            }
        ) as Array<Pointage>;

        //Retirer les enfants déja pointer
        pointageActifTemps.forEach((pointage: Pointage) => {
            /*let i: any = listind.findIndex(
                (enfant) => {enfant.getId() === pointage.getIdIndividu()
                }              
            );
            
            listind.splice(i, 1);*/
            listind = listind.filter((e : Individu)=>{
                return e.getId() !== pointage.getIdIndividu()
            })
        });
        //console.log("pointageActifTemps: ",pointageActifTemps)
        
        //Si tous les enfants sont pointer, donc supp pointages
        if (listind.length === 0) {
            console.log("Si tous les enfants sont pointer, donc supp pointages")
            listind = Array.from(rootGetters.getFiltredListIndividus);
            const listindIds = listind.map((ind : Individu)=> ind.getId())
            pointageActifTemps.forEach((pointage: Pointage) => {
                //listind.forEach((indv : Individu) =>{
                    if (!pointage.isIsInoe() && listindIds.includes(pointage.getIdIndividu())){
                        pointage.set_deleted(true);
                    }
                //})
            });
            let lastaction = {
                name: "SuppressionMasse",
                value: pointageActifTemps
            }
            commit(s.SET_LAST_ACTION, lastaction);

            api.pointagesController.pointageMasse(pointageActifTemps).then((rep: any) => {
                dispatch("fetchListPointages")
                rep.length === 0 ? resolve("Success") : reject("")
            })
        } else {
            console.log("tous les enfants ne sont pas pointer, donc pointe tous !")
            
            listind.forEach((ind: Individu) => {
                let pointage = new Pointage({});
                let inscription = ind.getInscriptionActivite(currentActiviteId);
                if (typeof inscription !== 'undefined' && inscription) {
                    pointage.setIdInscription(inscription.getId());
                    if (rootGetters.getCurrentActivite.isGroupes()) {
                        pointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                    } else {
                        pointage.setGroupeId(-1)
                    }

                } else {
                    reject("InscriptionNotFound")
                }
                pointage.setTempsDebut(seance.getStart_date());
                pointage.setTempsFin(seance.getEnd_date());
                pointage.setDatePointage(currentDate.format('YYYYMMDD'));
                pointage.setTypePointage("REEL");
                pointage.setIdIndividu(ind.getId());
                pointage.setUsername(currentUser.login);
                if (seance.getResource_id() === 'AC' || seance.getResource_id() === 'JO') {
                    previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && item.individu_id === ind.getId());
                    pointage.setElementFriseId(seance.getFriseElement_id());
                    pointage.set_id("pointageAN" + currentDate.format('YYYYMMDD') + currentActiviteId + seance.getFriseElement_id() + ind.getId());
                } else {
                    if (seance.getResource_id() === 'TS') {
                        previ = listPrevi.find((item: any) => item.tariftempssupplactivite_id === seance.getTempsTarif_id() && item.individu_id === ind.getId());
                        pointage.setTempsSupplementaireId(seance.getTempsTarif_id());
                        pointage.setTempsSupplementaireIntitule(seance.getPlageIntitule());
                        pointage.set_id("pointageAN" + currentDate.format('YYYYMMDD') + currentActiviteId + seance.getTempsTarif_id() + ind.getId());
                    }
                }
                if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
                    pointage.setPaletteId(previ.palette_id);
                } else {
                    pointage.setPaletteId(palette.getId());
                }
                pointage.setIsInoe(false);
                listpointage.push(pointage);
            });
            let lastaction = {
                name: "PointageMasse",
                value: listpointage
            }
            commit(s.SET_LAST_ACTION, lastaction);
            api.pointagesController.pointageMasse(listpointage).then((rep: any) => {
                rep.length === 0 ? resolve("Success") : reject("")
            }).finally(() => {
                dispatch("fetchListPointages")
            })

        }
    })
};
export const pointageSupplementTAC: Action<PointageState, RootState> = ({ dispatch, state, rootGetters }, params) => {
    let supp: TarifActiviteDocument = params[0];
    let ind: Individu = params[1];

    let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
    let currentActiviteId = rootGetters.getCurrentActivite.getId();
    let listSuppActifs = state.listSupplementsActifs.map((supplement: any) =>
        supplement.get_id()
    );
    //Vérifier si c'est un Ajout ou une Suppression
    if (listSuppActifs.includes("supplementAN" + currentDate.format("YYYYMMDD") + currentActiviteId + supp.getId() + ind.getId())) {
        dispatch('removeSupplement', params);
    } else {
        dispatch('addSupplement', params);
    }
};
export const addSupplement: Action<PointageState, RootState> = ({ dispatch, rootGetters }, params) => {
    return new Promise((resolve, reject) => {
        let supp: TarifActiviteDocument = params[0];
        let ind: Individu = params[1];
        let supplement = new Supplement({});
        //let now = utils.getCurrentTimeNow();
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        let currentUser = rootGetters.getCurrentUser;

        supplement.set_id("supplementAN" + currentDate.format('YYYYMMDD') + currentActiviteId + supp.getId() + ind.getId());
        supplement.setChecked(true);
        supplement.setFactureEnAttente(false);
        let inscription = ind.getInscriptionActivite(currentActiviteId);
        if (typeof inscription !== 'undefined' && inscription) {
            supplement.setInscriptionId(inscription.getId());

        } else {
            reject("InscriptionNotFound")
        }
        supplement.setIntitule(supp.getPlageIntitule());
        supplement.setIsFacture(false);
        supplement.setModifieApresFacture(false);
        supplement.setNomEnfant(ind.getDisplayName());
        supplement.setOrdreListeAttente(0);
        supplement.setPointageDate(currentDate.format('YYYY-MM-DDTHH:mm:ss'));
        supplement.setSupplementId(supp.getId());
        supplement.setTelephone('');
        supplement.setTooltipNumFacture('');
        supplement.setTypePointage('REEL');
        supplement.setTypeSupplement('SU');
        supplement.setVersion(0);
        supplement.setIsInoe(false);
        supplement.setUsername(currentUser.login);



        api.pointagesController.addSupplement(supplement).then((rep: any) => {
            rep.ok ? resolve("Success") : reject("")
        }).finally(() => {
            dispatch("fetchSupplementActifs")
        })
    })
};
export const removeSupplement: Action<PointageState, RootState> = ({ dispatch, rootGetters }, params) => {
    return new Promise((resolve, reject) => {
        let supp: TarifActiviteDocument = params[0];
        let ind: Individu = params[1];
        //let now = utils.getCurrentTimeNow();
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let currentActiviteId = rootGetters.getCurrentActivite.getId();

        let doc_id = "supplementAN" + currentDate.format('YYYYMMDD') + currentActiviteId + supp.getId() + ind.getId();

        api.pointagesController.supprimerPointage(doc_id).then((rep: any) => {
            console.log("DELETE", rep)
            rep.ok ? resolve("Success") : reject("")
        }).finally(() => {
            dispatch("fetchSupplementActifs")
        })

    })
};
export const removeSupplementHeure: Action<PointageState, RootState> = ({ dispatch }, suppActif) => {
    return new Promise((resolve, reject) => {
        let supp: Supplement = suppActif;
        api.pointagesController.supprimerPointage(supp.get_id()).then((rep: any) => {
            console.log("DELETE", rep)
            rep.ok ? resolve("Success") : reject("")
            dispatch("fetchSupplementActifs")
        }).catch((e: any) => {
            console.error(e)
            router.push("/erreurs/" + e);
        })
    })
};
export const addSupplementMasse: Action<PointageState, RootState> = ({ rootGetters, getters, dispatch, commit }, params) => {
    return new Promise((resolve, reject) => {
        let supplement: TarifActiviteDocument = params;
        let listind: Array<Individu> = Array.from(rootGetters.getFiltredListIndividus);
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let listSupp: Array<Supplement> = [];
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        let currentUser = rootGetters.getCurrentUser;
        //Recup Suplement actif
        let suppActif = getters.getSupplementsActifs as Array<Supplement>;
        //Filtrer 
        let filtredSuppActif: Array<Supplement> = suppActif.filter(
            (item: Supplement) => item.getSupplementId() === supplement.getId()) as Array<Supplement>;
        //Retirer les enfants avec suppléments
        filtredSuppActif.forEach((sup: Supplement) => {
            let i: any = listind.findIndex(
                enfant => enfant.getInscription_id() === sup.getInscriptionId()
            );
            listind.splice(i, 1);
        });
        //Si tous les enfants sont pointer, donc del supplement
        if (listind.length === 0) {
            listind = Array.from(rootGetters.getFiltredListIndividus);
            filtredSuppActif.forEach((supp: Supplement) => {
                if (!supp.isIsInoe())
                    supp.set_deleted(true);
            });

            let lastaction = {
                name: "SuppressionMasse",
                value: filtredSuppActif
            }
            commit(s.SET_LAST_ACTION, lastaction);
            api.pointagesController.supplementMasse(filtredSuppActif).then((rep: any) => {
                console.log("SuppressionMasse", rep)
                rep.length === 0 ? resolve("Success") : reject("")
            }).finally(() => {
                dispatch("fetchSupplementActifs")
            })
        } else {
            listind.forEach((ind: Individu) => {
                let s = new Supplement({});

                s.set_id("supplementAN" + currentDate.format('YYYYMMDD') + currentActiviteId + supplement.getId() + ind.getId());
                s.setChecked(true);
                s.setFactureEnAttente(false);
                let inscription = ind.getInscriptionActivite(currentActiviteId);
                if (typeof inscription !== 'undefined' && inscription) {
                    s.setInscriptionId(inscription.getId());

                } else {
                    reject("InscriptionNotFound")
                }
                s.setIntitule(supplement.getPlageIntitule());
                s.setIsFacture(false);
                s.setModifieApresFacture(false);
                s.setNomEnfant(ind.getDisplayName());
                s.setOrdreListeAttente(0);
                s.setPointageDate(currentDate.format('YYYY-MM-DDTHH:mm:ss'));
                s.setSupplementId(supplement.getId());
                s.setTelephone('');
                s.setTooltipNumFacture('');
                s.setTypePointage('REEL');
                s.setTypeSupplement('SU');
                s.setVersion(0);
                s.setIsInoe(false);
                s.setUsername(currentUser.login)
                listSupp.push(s);
            });

            let lastaction = {
                name: "SupplementMasse",
                value: listSupp
            }
            commit(s.SET_LAST_ACTION, lastaction);
            api.pointagesController.supplementMasse(listSupp).then((rep: any) => {
                console.log("SupplementMasse", rep)
                rep.length === 0 ? resolve("Success") : reject("")
            }).finally(() => {
                dispatch("fetchSupplementActifs")
            })

        }
    })
};
export const undoLastActionTAC: Action<PointageState, RootState> = ({ state, getters, dispatch, commit }) => {
    return new Promise((resolve, reject) => {
        let lastaction = state.lastAction;
        switch (lastaction.name) {
            case 'PointageMasse':
                {
                    let pointageactif = getters.getPointageEnCours as Array<Pointage>;

                    pointageactif = pointageactif.filter((pointage: Pointage) => {
                        if (lastaction.value.some((element: Pointage) => pointage.get_id() === element.get_id())) {
                            return pointage;
                        }
                    })
                    pointageactif.forEach((element: Pointage) => {
                        element.set_deleted(true);
                    });
                    lastaction.value = pointageactif;
                    break;
                }
            case 'SupplementMasse':
                {
                    let suppActif = getters.getSupplementsActifs as Array<Supplement>;
                    suppActif = suppActif.filter((supplement: Supplement) => {
                        if (lastaction.value.some((element: Supplement) => supplement.get_id() === element.get_id())) {
                            return supplement;
                        }
                    })
                    suppActif.forEach((element: Supplement) => {
                        element.set_deleted(true);
                    });
                    lastaction.value = suppActif;
                    break;
                }
            case 'SuppressionMasse':
                {
                    lastaction.value.forEach((element: any) => {
                        element.set_deleted(false);
                    });
                    break;
                }
            default:
                break;
        }
        if (lastaction.name !== 'NoAction') {
            api.pointagesController.updateDocument(lastaction.value).then((rep: any) => {
                rep.ok ? resolve("Success") : reject("")
            }).finally(() => {
                commit(s.SET_LAST_ACTION, {
                    name: "NoAction",
                    value: "NoValue"
                })
                Promise.all([dispatch("fetchSupplementActifs"), dispatch("fetchListPointages")]);
            })
        }

    })
};
export const confReservationTAC: Action<PointageState, RootState> = ({ dispatch }) => {
    return new Promise((resolve, reject) => {
        let listPromise: Array<Promise<any>> = [];
        listPromise.push(dispatch('confReservationPointageTAC'));
        listPromise.push(dispatch('confReservationSupplementsTAC'));

        Promise.all(listPromise).then((rep: any) => {
            console.warn("conf-reserve", rep);
            if (rep[0] !== "no-previsionnel" || rep[1] !== "no-previsionnel") {
                resolve("confreservation done");
            } else {
                router.push("/erreurs/no-previsionnel")
                reject('no-previsionnel')
            }

        });

    })
};
export const confReservationSupplementsTAC: Action<PointageState, RootState> = ({ state, dispatch, commit, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let listSupplementsPointer: Array<Supplement> = [];

        let listSupplementsActifs: Array<string> = state.listSupplementsActifs.map((supp: Supplement) => supp.get_id());
        let listind: Array<Individu> = Array.from(rootGetters.getFiltredListIndividus);
        //let now = utils.getCurrentTimeNow();
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        let currentUser = rootGetters.getCurrentUser;

        //Recup les Supppléments filtrer depuis Params
        let listSuppParams: Array<TarifActiviteDocument> = state.listSupplementsFiltred;
        //Recup les supplements prévisionnel
        let listPrevi = state.listSupplementsPrevi;
        //Filtrer la liste
        listPrevi = listPrevi.filter((item: any) => listSuppParams.some(supp => supp.getId() === item.supplement_id && !supp.isIsAuto()));
        if (listPrevi.length != 0) {
            listPrevi.forEach(supp => {
                let ind: Individu | undefined = listind.find((individu: Individu) => individu.getId() === supp.individu_id);
                let supplement: TarifActiviteDocument | undefined = listSuppParams.find((s: TarifActiviteDocument) => s.getId() === supp.supplement_id);

                if (typeof ind !== 'undefined' && typeof supplement !== 'undefined') {
                    let s = new Supplement({});

                    s.set_id("supplementAN" + currentDate.format('YYYYMMDD') + currentActiviteId + supplement.getId() + ind.getId());
                    s.setChecked(true);
                    s.setFactureEnAttente(false);
                    let inscription = ind.getInscriptionActivite(currentActiviteId);
                    if (typeof inscription !== 'undefined' && inscription) {
                        s.setInscriptionId(inscription.getId());
                    } else {
                        reject("InscriptionNotFound")
                    }
                    s.setIntitule(supplement.getPlageIntitule());
                    s.setIsFacture(false);
                    s.setModifieApresFacture(false);
                    s.setNomEnfant(ind.getDisplayName());
                    s.setOrdreListeAttente(0);
                    s.setPointageDate(currentDate.format('YYYY-MM-DDTHH:mm:ss'));
                    s.setSupplementId(supplement.getId());
                    s.setTelephone('');
                    s.setTooltipNumFacture('');
                    s.setTypePointage('REEL');
                    s.setTypeSupplement('SU');
                    s.setVersion(0);
                    s.setIsInoe(false);
                    s.setUsername(currentUser.login);
                    listSupplementsPointer.push(s);
                } else {
                    reject('NoIndWithPrevi')
                }
            });

            //On retire les pointages existants
            listSupplementsPointer = listSupplementsPointer.filter((suppl: Supplement) => !listSupplementsActifs.includes(suppl.get_id()));
            api.pointagesController.supplementMasse(listSupplementsPointer).then((rep: any) => {
                rep.length === 0 ? resolve("Success") : reject("")
            }).finally(() => {
                dispatch("fetchSupplementActifs")
            })
        } else {
            resolve('no-previsionnel');
        }


    })
}
export const confReservationPointageTAC: Action<PointageState, RootState> = ({ state, dispatch, commit, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let listPointage: Array<Pointage> = [];

        let listPointageActifs: Array<string> = state.pointageEnCours.map((pointage: Pointage) => pointage.get_id());
        let listind: Array<Individu> = Array.from(rootGetters.getFiltredListIndividus);
        let currentActiviteId = rootGetters.getCurrentActivite.getId();
        let currentDate = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        let currentUser = rootGetters.getCurrentUser;
        let palette: PaletteDocument = state.paletteEncours;
        let previ: any;

        //Recup Temps filtrer depuis Params
        let listSeanceParams: Array<TarifEventSchedulerActiviteDocument> = state.listTempsAccueilFiltred;

        //Recup les pointages prévisionnel
        let listPrevi = state.listPointagesPrevi;
        //Filtrer la liste
        listPrevi = listPrevi.filter((item: any) => {
            if (
                (typeof item.elementfrise_id !== 'undefined' &&
                    listSeanceParams.some(seance => seance.getFriseElement_id() === item.elementfrise_id))
                ||
                (typeof item.tariftempssupplactivite_id !== 'undefined' &&
                    listSeanceParams.some(seance => seance.getTempsTarif_id() === item.tariftempssupplactivite_id))
            ) {
                return item;
            }
        });

        if (listPrevi.length != 0) {
            listPrevi.forEach(temps => {
                let ind: Individu | undefined = listind.find((individu: Individu) => individu.getId() === temps.individu_id);
                if (typeof ind !== 'undefined') {
                    let pointage = new Pointage({});
                    let seance: any;
                    let inscription = ind.getInscriptionActivite(currentActiviteId);
                    if (typeof inscription !== 'undefined' && inscription) {
                        pointage.setIdInscription(inscription.getId());
                        if (rootGetters.getCurrentActivite.isGroupes()) {
                            pointage.setGroupeId(inscription.getHistoGroupe().getGroupeActivite().getId())
                        } else {
                            pointage.setGroupeId(-1)
                        }

                    } else {
                        reject("InscriptionNotFound")
                    }
                    if (typeof temps.elementfrise_id !== 'undefined') {
                        seance = listSeanceParams.find((s: TarifEventSchedulerActiviteDocument) => s.getFriseElement_id() === temps.elementfrise_id);
                        previ = listPrevi.find((item: any) => item.elementfrise_id === seance.getFriseElement_id() && typeof ind !== 'undefined' && item.individu_id === ind.getId());
                        pointage.setElementFriseId(seance.getFriseElement_id());
                        pointage.set_id("pointageAN" + currentDate.format('YYYYMMDD') + currentActiviteId + seance.getFriseElement_id() + ind.getId());
                    } else {
                        if (typeof temps.tariftempssupplactivite_id !== 'undefined') {
                            seance = listSeanceParams.find((s: TarifEventSchedulerActiviteDocument) => s.getTempsTarif_id() === temps.tariftempssupplactivite_id);
                            previ = listPrevi.find((item: any) => item.tariftempssupplactivite_id === seance.getTempsTarif_id() && typeof ind !== 'undefined' && item.individu_id === ind.getId());
                            pointage.setTempsSupplementaireId(seance.getTempsTarif_id());
                            pointage.setTempsSupplementaireIntitule(seance.getPlageIntitule());
                            pointage.set_id("pointageAN" + currentDate.format('YYYYMMDD') + currentActiviteId + seance.getTempsTarif_id() + ind.getId());
                        }
                    }
                    pointage.setTempsDebut(seance.getStart_date());
                    pointage.setTempsFin(seance.getEnd_date());
                    pointage.setDatePointage(currentDate.format('YYYYMMDD'));
                    pointage.setTypePointage("REEL");
                    pointage.setIdIndividu(ind.getId());

                    if (palette.getId() === -32 && typeof previ !== 'undefined' && previ.palette_id !== -31) {
                        pointage.setPaletteId(previ.palette_id);
                    } else {
                        pointage.setPaletteId(palette.getId());
                    }
                    pointage.setIsInoe(false);
                    pointage.setUsername(currentUser.login);

                    listPointage.push(pointage)
                } else {
                    reject('NoIndWithPrevi')
                }
            });
            //On retire les pointages existants
            listPointage = listPointage.filter((pointage: Pointage) => !listPointageActifs.includes(pointage.get_id()))

            api.pointagesController.pointageMasse(listPointage).then((rep: any) => {
                rep.length === 0 ? resolve("Success") : reject("")
            }).finally(() => {
                dispatch("fetchListPointages")
            })
        } else {
            resolve('no-previsionnel')
        }

    })
};

export const fetchIndividusPresents: Action<PointageState, RootState> = ({ commit, state, rootGetters, getters }) => {
    return new Promise((resolve, reject) => {
        let individusPresents: Array<Individu> = []
        let individus: Array<Individu> = rootGetters.getListIndividus
        let now = utils.getCurrentTimeNow()
        let palettesPresence = getters.getListPalettePresence.map((p: PaletteDocument) =>
            p.getId()
        );
        let palettesAbsence = getters.getListPaletteAbsence
        let p: boolean
        individus.forEach((ind: Individu) => {
            p = false
            let pointages = state.pointageEnCours.filter((item: any) => item.idIndividu === ind.getId())
            if (pointages)
                pointages.forEach((pointage: Pointage) => {
                    if (
                        palettesPresence.includes(pointage.getPaletteId()) &&
                        (
                            now.isBetween(
                                utils.getDateFromString(pointage.getTempsDebut(), "YYYY-MM-DD HH:mm:ss"),
                                utils.getDateFromString(pointage.getTempsFin(), "YYYY-MM-DD HH:mm:ss")
                            ) ||
                            (
                                pointage.getTempsFin() === "" &&
                                utils.getDateFromString(pointage.getTempsDebut(), "YYYY-MM-DD HH:mm:ss") <= now
                            )
                        )
                    ) {
                        p = true
                    }
                });
            if (p) individusPresents.push(ind)
        })
        commit(s.SET_INDIVIDUS_PRESENT, individusPresents)
    })
};

export const fetchIndividusFiltreesPresents: Action<PointageState, RootState> = ({ commit, state, rootGetters, getters }) => {
    return new Promise((resolve, reject) => {
        let individusPresents: Array<Individu> = []
        let individus: Array<Individu> = rootGetters.getFiltredListIndividus;
        let now = utils.getCurrentTimeNow()
        let palettesPresence = getters.getListPalettePresence.map((p: PaletteDocument) =>
            p.getId()
        );
        let palettesAbsence = getters.getListPaletteAbsence
        let p: boolean
        individus.forEach((ind: Individu) => {
            p = false
            let pointages = state.pointageEnCours.filter((item: any) => item.idIndividu === ind.getId())
            if (pointages)
                pointages.forEach((pointage: Pointage) => {
                    if (
                        palettesPresence.includes(pointage.getPaletteId()) &&
                        (
                            now.isBetween(
                                utils.getDateFromString(pointage.getTempsDebut(), "YYYY-MM-DD HH:mm:ss"),
                                utils.getDateFromString(pointage.getTempsFin(), "YYYY-MM-DD HH:mm:ss")
                            ) ||
                            (
                                pointage.getTempsFin() === "" &&
                                utils.getDateFromString(pointage.getTempsDebut(), "YYYY-MM-DD HH:mm:ss") <= now
                            )
                        )
                    ) {
                        p = true
                    }
                });
            if (p) individusPresents.push(ind)
        })
        commit(s.SET_INDIVIDUS_FILTREES_PRESENT, individusPresents)
    })
};
export const resetLastAction: Action<PointageState, RootState> = ({ commit }) => {
    let lastAction = {
        name: "NoAction",
        value: "NoValue"
    };
    commit(s.SET_LAST_ACTION, lastAction);
};
export const filterListTempsAccueil: Action<PointageState, RootState> = ({ commit, state }, params?: Array<number>) => {
    let listTempsAccueil = state.listTempsAccueil;
    if (typeof params !== 'undefined' && Array.isArray(params))
        commit(s.SET_LIST_TEMPS_ACCUEIL_FILTRED,
            listTempsAccueil.filter((temps: TarifEventSchedulerActiviteDocument) => params.includes(temps.getId()))
        )
    else
        commit(s.SET_LIST_TEMPS_ACCUEIL_FILTRED, listTempsAccueil);
};
export const filterListSupplement: Action<PointageState, RootState> = ({ commit, state }, params?: Array<number>) => {
    let listSupplement = state.listSupplements;
    if (typeof params !== 'undefined' && Array.isArray(params))
        commit(s.SET_LIST_SUPPLEMENTS_FILTRED,
            listSupplement.filter((supp: TarifActiviteDocument) => params.includes(supp.getId()))
        );
    else
        commit(s.SET_LIST_SUPPLEMENTS_FILTRED, listSupplement);
};
export const actions: ActionTree<PointageState, RootState> = {
    fetchListPointages,
    addPointageArrivee,
    addPointageDepart,
    editPointage,
    addPointageArriveeGlobal,
    addPointageDepartGlobal,
    removePointage,
    removeAllPointages,
    addPointageTS,
    removePointageTS,
    pointageTSGlobal,
    fetchListTempsAccueil,
    fetchPointagePrevi,
    setPaletteEncours,
    fetchListSupplement,
    fetchSupplementActifs,
    addSupplement,
    removeSupplement,
    removeSupplementHeure,
    addSupplementMasse,
    undoLastAction,
    confReservation,
    confReservationSupplements,
    confReservationPointage,
    fetchAll,
    fetchPointageReel,
    fetchPalette,
    fetchGroupes,
    fetchRegim,
    fetchSuppPrévi,
    fetchSuppReel,
    pointageTemps,
    addPointageTAC,
    removePointageTAC,
    addPointageMasseAvecTemps,
    pointageSupplementTAC,
    undoLastActionTAC,
    confReservationTAC,
    confReservationSupplementsTAC,
    confReservationPointageTAC,
    fetchIndividusPresents,
    resetLastAction,
    fetchVieQuoRegimeAli,
    fetchIndividusFiltreesPresents,
    filterListTempsAccueil,
    filterListSupplement,
    removeDeletedSupplements,
    removeDeletedPointages
}
